import clsx from 'clsx';
import { ReactNode, useRef } from 'react';

import { FooterQuery, NavigationQuery } from '@/api';
import { Footer } from '@/components/footer/Footer';
import { Navigation } from '@/components/navigation/Navigation';

type Props = {
  children: ReactNode;
  invertedColor?: boolean;
  footerData: FooterQuery;
  headerData: NavigationQuery;
};

export const Layout = ({
  children,
  invertedColor,
  footerData,
  headerData,
}: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <main ref={ref} className={clsx('scroll-smooth')}>
      <Navigation data={headerData} invertedColor={invertedColor} />
      {children}
      <Footer data={footerData} />
    </main>
  );
};
